<script lang="ts">
import Toast from 'primevue/toast'
import ConfirmDialog from "primevue/confirmdialog"
import {useAuthStore} from "@/stores/auth.store"
import {useThemeStore} from "@/stores/theme.store"
import {useAppLoadingStore} from "@/stores/appLoading.store"

export default {
  components: {
    Toast,
    ConfirmDialog,
  },
  computed: {
    authStore() {
      return useAuthStore()
    },
    appLoadingStore() {
      return useAppLoadingStore()
    },
  },
  mounted() {
    const themeStore = useThemeStore()
    themeStore.initTheme()
  }
}
</script>

<template>
  <div :class="'app_container'+ (appLoadingStore.isLoading ? ' loading' : '')">
    <Toast />
    <ConfirmDialog />
    <div v-if="appLoadingStore.isLoading" class="loader">
      <i class="pi pi-spin pi-spinner"></i>
    </div>
    <RouterView />
  </div>
</template>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');

*{
  font-family: 'Roboto', sans-serif;
  margin: 0;
  padding: 0;
}
.app_container{
  width: 100%;
  margin: 0;
  &.loading{
    pointer-events: none;
    height: 20rem;
    .loader{
      position: fixed;
      background-color: rgba(0, 0, 0, 0.5);
      top:0;
      left:0;
      right:0;
      bottom:0;
      z-index: 1000;
      i{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 2rem;
      }
    }
  }
}
</style>
